<template>
    <div id="incentive">
        <div class="hero hero-drops">
            <svg class="drop-gray-1" width="439" height="531" viewBox="0 0 439 531" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M322.2 0L26 296.2C10 312.2 10 338.2 26 354.3C42 370.3 68 370.3 84.1 354.3L438.4 0H322.2Z" fill="url(#paint0_linear-svg-1)"/>
                <path d="M277.9 195.1L12 460.9C-4 476.9 -4 502.9 12 519C28 535 54 535 70.1 519L336 253.1C352 237.1 352 211.1 336 195C328 187 317.5 183 307 183C296.4 183.1 285.9 187.1 277.9 195.1Z" fill="url(#paint1_linear)"/>
                <defs>
                <linearGradient id="paint0_linear-svg-1" x1="109" y1="218" x2="615" y2="-14" gradientUnits="userSpaceOnUse">
                <stop stop-color="#EDF0F7" stop-opacity="0.75"/>
                <stop offset="1" stop-color="white"/>
                </linearGradient>
                <linearGradient id="paint1_linear" x1="77.8982" y1="390.109" x2="512.043" y2="218.305" gradientUnits="userSpaceOnUse">
                <stop stop-color="#EDF0F7" stop-opacity="0.75"/>
                <stop offset="1" stop-color="white"/>
                </linearGradient>
                </defs>
            </svg>

            <svg class="drop-gray-2" width="224" height="223" viewBox="0 0 224 223" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M223.1 111.5C223.1 173.1 173.2 223 111.6 223C49.9999 223 0.0998535 173.1 0.0998535 111.5C0.0998535 49.9 49.9999 0 111.6 0C173.2 0 223.1 49.9 223.1 111.5Z" fill="#EDF0F7"/>
            </svg>          

            <div class="slider">
                <Slick ref="slick-hero-home" :options="slickOptions">
                    <div class="slide">
                        <div class="image">
                            <img class="thumb" src="img/incentive/hero.png" />
                        </div>
                        <div class="caption">
                            <h1 class="text h1">Viaggi incentive for a new world</h1>
                            <div class="small h4">
                                User Experience first. E poi consistenza, flessibilità, sicurezza.
                                <br>
                                Una razionale allocazione del budget senza rinunciare alla creatività e alla comunicazione dei valori aziendali.                                
                            </div>
                        </div>
                    </div>
                </Slick>

                <!--
                <div class="slider--nav">
                    <div id="hero-slider-prev" class="arrow"><SvgChevronLeft /></div>
                    <div id="hero-slider-next" class="arrow"><SvgChevronRight /></div>
                </div>
                -->
            </div>

            <ScrollTo selector="#scroll" />
        </div>

        <section class="extraQuote" id="scroll">
            <b-container class="text-center">
                <div class="image">
                    <svg width="1546" height="552" viewBox="0 0 1546 552" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M193.076 13.8771C155.827 23.3719 119.454 37.9793 88.6328 61.059C57.8111 84.1388 33.1245 116.421 23.3375 153.524C10.6291 201.875 18.6632 252.124 4.49396 300.475C-7.33805 340.791 4.64004 384.175 35.1696 413.536C64.9687 442.167 108.353 454.583 149.546 451.223C190.739 447.864 229.887 429.751 262.753 404.48C280.136 391.187 296.204 375.703 315.778 366.062C351.566 348.241 394.512 351.747 433.222 362.118C471.932 372.489 508.888 389.142 548.182 396.592C587.476 404.041 631.591 400.974 662.559 375.703C687.683 355.253 700.83 322.824 705.212 290.688C709.595 258.698 706.235 225.1 691.627 196.47C673.952 161.85 641.962 137.018 610.556 113.938C581.487 92.6111 552.126 71.7225 520.428 54.4857C454.549 18.5514 379.174 0 303.8 0C266.551 0 229.302 4.5283 193.076 13.8771Z" fill="url(#paint0_linear)"/>
                    <path d="M1503 551L259.625 517.346C245.026 517.346 232.226 501.361 228.026 477.803L166.429 167.683C160.03 132.01 175.929 96 198.028 96H1435.97C1450.57 96 1463.37 112.154 1467.57 135.543L1543.56 479.317C1549.96 514.99 1539 555 1503 551Z" fill="#FDC500"/>
                    <path d="M1478 516H252C223 516 210.226 500.014 206.026 476.457L144.429 132.683C138.029 97.0096 155 61 194 61H1417C1450 61 1455.77 77.1538 1459.97 100.543L1521.56 444.317C1527.96 479.99 1512 516 1478 516Z" fill="#39414E"/>
                    <path d="M397.529 112.1L374.029 169.5C385.529 177.3 391.229 190.4 391.229 204.5C391.229 230.6 372.429 248.8 346.829 248.8C323.329 248.8 302.529 233.1 302.529 204.5C302.529 190.9 307.729 179.5 314.529 169L353.629 112.1H397.529ZM489.329 204.4C489.329 230.5 470.529 248.7 445.029 248.7C421.529 248.7 400.729 233 400.729 204.4C400.729 190.8 405.929 179.4 412.729 168.9L451.829 112H495.629L472.129 169.4C483.629 177.3 489.329 190.3 489.329 204.4Z" fill="white"/>
                    <defs>
                    <linearGradient id="paint0_linear" x1="352.758" y1="484.869" x2="352.758" y2="59.2169" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF974F"/>
                    <stop offset="0.00128142" stop-color="#FF974F"/>
                    <stop offset="1" stop-color="#FF5652"/>
                    </linearGradient>
                    </defs>
                    </svg>
                </div>
                <div class="text">
                    E' già tutto cambiato nel mondo dei viaggi incentive. Le parole d'ordine dell'era Covid e post-Covid sono sostenibilità e digitale. Le aziende che incentivano la rete vendita puntano ad una efficiente allocazione delle risorse. I destinatari degli incentive cercano premi con un valore chiaro e flessibilità d’uso.
                </div>
            </b-container>
        </section>

        <section class="boxed-text">
            <p class="text text-center">
                Nelle incentivazioni della forza vendite e delle reti distributive il viaggio è da sempre un classico. Ma sembra lontano il tempo delle grandi operazioni di gruppo con voli charter e complessi programmi.
            </p>
        </section>

        <section class="section--card-cofanetti credito-travel">
            <b-container fluid>
                <div class="content">
                    <img class="bg" src="img/incentive/credito-travel.png" />
                    <h2 class="title h4">Credito travel, gift card digitali e cofanetti digitali. <br>I nostri viaggi incentive 2.0</h2>
                </div>
                <div class="drop">
                    <img class="bg" src="img/card-cofanetti-bg.svg" />
                    <div class="text">
                        Con le nostre soluzioni digitali realizzi soluzioni di viaggio incentive di semplice gestione per la tua azienda e di grande flessibilità e tangibile valore per il partner destinatario dell'operazione.
                    </div>
                </div>
            </b-container>
        </section>

        <section class="section--card-with-background">
            <img class="floatingImg" src="img/incentive/card-bg.png" />
            <div class="content">
                <div class="card">
                    <div class="icon"><img src="img/incentive/icon-1.svg"/></div>
                    <h3 class="title">User Experience</h3>
                    <p class="text">
                        Una piattaforma di online travel booking con standard di usabilità che rispondono alle attese dell'utente contemporaneo abituato alla UX delle grandi agenzie globali come Expedia o Booking.
                        <br><br>
                        Il tuo partner commerciale potrà <b>fruire del suo premio incentive sotto forma di credito virtuale in totale autonomia e con completa flessibilità.</b>
                    </p>
                </div>
                <div class="card">
                    <div class="icon"><img src="img/incentive/icon-2.svg"/></div>
                    <h3 class="title">Integrazione</h3>
                    <p class="text">
                        Le nostre soluzioni sono facilmente integrabili con le tue piattaforme IT quali <b>intranet, extranet, gestionali, siti web e mobile app.</b>
                        <br><br>
                        Il risultato è la possibilità di mettere in palio viaggi, che sono sempre molto desiderati, ma in un modo moderno, semplice e facile da gestire.
                    </p>
                </div>
                <div class="card">
                    <div class="icon"><img src="img/incentive/icon-3.svg"/></div>
                    <h3 class="title">I tuoi valori e la tua comunicazione</h3>
                    <p class="text">
                        A fronte di una dimensione digitale integrata non ti chiediamo di rinunciare alla comunicazione.
                        <br><br>
                        Possiamo <b>velocemente creare proposte di viaggio coordinate</b> con i messaggi e il mood della tua campagna.
                        <br><br>
                        Tutto questo lasciando <b>al vincitore del viaggio incentive totale libertà</b> e flessibilità di scelta di destinazioni, properties, partecipanti al viaggio e date.
                    </p>
                </div>
                <div class="card">
                    <div class="icon"><img src="img/incentive/icon-4.svg"/></div>
                    <h3 class="title">Il tuo Brand</h3>
                    <p class="text">
                        Non è solo la user journey del tuo incentive ad essere integrata con il nostro sito di travel booking ma lo è anche l'esperienza di brand.
                        <br><br>
                        <b>La brandizzazione delle nostre soluzioni è semplice e immediata.</b>
                    </p>
                </div>
            </div>
        </section>

        <section class="section--card-cofanetti">
            <b-container fluid>
                <h2 class="title text-center h2">CARD DIGITALI O TRADIZIONALI</h2>
                <div class="content">
                    <img class="bg" src="img/cards-bg.svg" />
                    <img class="cards" src="img/cards.png" />
                </div>
                <!--<div class="link"><a href="#" class="btn">Scopri di più</a></div>-->
                <div class="drop">
                    <img class="bg" src="img/card-cofanetti-bg.svg" />
                    <div class="text">
                        La tua campagna richiede l’utilizzo di card tangibili o cofanetti regalo? Nessun problema. Possiamo fornirti bellissime soluzioni di design, ugualmente brandizzabili.
                        <br>
                        Le nostre soluzioni “di carta” hanno l’anima digitale e garantiscono la sicurezza e la semplicità d’uso delle nostre soluzioni full-digital.
                    </div>
                </div>
            </b-container>
        </section>

        <b-container>
            <section>
                <FormContatti
                    formTitle="Contattaci"
                    formSubtitle="Per approfondire meglio le nostre soluzioni e quello che possiamo fare per il tuo marketing"
                />
            </section>
        </b-container>

        <section class="section--prefooter">
            <b-container fluid>
                <b-row>
                    <b-col sm="6">
                        <div class="content">
                            <h3 class="subtitle">
                                I piani incentive,<br>
                                cosa sono e come cambiano
                            </h3>
                            <div class="text">
                                <p>
                                    L’incentive viene inserito in una campagna di vendita al fine di stimolare la forza vendita o il trade al raggiungimento di prefissati obiettivi di marketing.
                                </p>

                                <p>
                                    > Deve avere un preciso limite temporale<br>
                                    > Deve essere collegato ad un obiettivo chiaro, preciso e misurabile nel tempo<br>
                                    > Deve essere motivante nei premi
                                </p>
                                
                                <p>
                                    Gli schemi più usuali di incentive sono:<br>
                                    -    a target: chi raggiunge l’obiettivo ottiene il premio;<br>
                                    -    a superamento del target: il premio sarà assegnato in misura via via più consistente quanto maggiore sarà la crescita percentuale sopra l’obiettivo;<br>
                                    -    a fasce: ad ogni fascia di risultati corrisponde un premio.
                                </p>

                                <p>
                                    Parlando di premio è necessario riflettere sulla tipologia di programmi incentive da proporre.
                                </p>

                                <p>
                                    La premialità che viene utilizzata è di vario genere:<br>
                                    -    Premi tangibili: in questa categoria rientrano i buoni, i voucher, le gift card e i biglietti del treno, dell’aereo, della lotteria.<br>
                                    -    Premi emotivi: l’emozione è il fattore predominante. I beni emotivi sono normalmente esposti in un catalogo, dove si possono trovare tutti i prodotti delle marche più prestigiose. L’azienda inserisce nel catalogo anche biglietti per eventi esclusivi e determinati servizi: corsi di vela, di guida sicura o di subacquea e anche il viaggio.                                    
                                </p>

                                <p>
                                    Il viaggio incentive di gruppo, lussuoso, originale, con complessi programmi e attività, è una specie di must dell’incentivazione degli ultimi trent’anni. In effetti la crisi Covid ha praticamente azzerato questa opzione e al suo posto si stanno affermando surrogati interessanti di tipo digitale come card e cofanetti viaggio.                                    
                                </p>

                                <p>
                                    Il plus offerto dalle soluzioni Vivamod è la grande consistenza, la sua semplicità d’uso sia per l’azienda che per il partner incentivato, la sua flessibilità e sicurezza.
                                </p>

                            </div>
                        </div>
                    </b-col>
                    <b-col sm="6">
                        <div class="image">
                            <div class="image" style="background-image:url('../../../../img/incentive/prefooter.jpg')"></div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </section>

    </div>
</template>

<script>
    import Slick from 'vue-slick'
    import FormContatti from '@/components/blocks/form-contatti'
    import ScrollTo from '@/components/atoms/scroll-to'
    //import SvgChevronLeft from '@/components/svg/chevron-left'
   // import SvgChevronRight from '@/components/svg/chevron-right'
    
    export default {
        name: 'concorsi',
        metaInfo: {
          title: 'Viaggi incentive - Soluzioni di online travel booking',
          meta: [
            { vmid: 'metaDescription', name: 'Description', content: 'Soluzioni Business per Viaggi incentive con una razionale allocazione del budget, creatività e comunicazione dei valori aziendali.' },
            { vmid: 'dcDescription', name: 'DC.description', lang: 'it', content: 'Soluzioni Business per Viaggi incentive con una razionale allocazione del budget, creatività e comunicazione dei valori aziendali.' },
            { vmid: 'ogTitle', property: 'og:title', content: 'Viaggi incentive - Soluzioni di online travel booking | Vivamod' },
            { vmid: 'ogDescription', name: 'og:description', content: 'Soluzioni Business per Viaggi incentive con una razionale allocazione del budget, creatività e comunicazione dei valori aziendali.' },
          ],
        },
        components: {
            Slick,
            FormContatti,
            ScrollTo,
            //SvgChevronLeft,
            //SvgChevronRight,
        },
        data()
        {
            return {
                slickOptions: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots:false,
                    fade:true,
                    arrows:true,
                    autoplay:true,
                    speed: 1500,
                    autoplaySpeed: 5500,
                    prevArrow: '#hero-slider-prev',
                    nextArrow: '#hero-slider-next',
                    responsive: [{
                        /*
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                        */
                    }]
                },
                bSlickOptions: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots:false,
                        //fade:true,
                        //arrows:false,
                        //autoplay:true,
                        speed: 500,
                        //autoplaySpeed: 7500,
                        prevArrow: '#b-left',
                        nextArrow: '#b-right',
                        responsive: [
                            {
                            breakpoint: 1140,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                            breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                },
            }
        },
        methods: {
        },
        mounted()
        {
        }
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../scss/_custom.scss';

    #incentive
    {
        .hero-drops
        {
            width:100%;
            overflow:hidden;
            max-width:1920px;
            position:relative;

            .drop-gray-1
            {
                position:absolute;
                top:46px;
                left:25%;
                width:46px;
                height:auto;
            }

            .drop-gray-2
            {
                position: absolute;
                top: 75%;
                left: 40%;
                width: 40px;
                height: auto;
            }

            .slider
            {
                position:relative;
                &--nav
                {
                    position:absolute;
                    padding:5px;
                    bottom:0;
                    display:flex;
                    .arrow
                    {
                        cursor:pointer;
                        transition:$transition-base;
                        &:hover
                        {
                            opacity:0.7;
                        }
                        path
                        {
                            stroke:$secondary;
                        }
                    }
                    @include media-breakpoint-up(lg)
                    {
                        right:0;
                        bottom:60px;
                        left:auto;
                        .arrow
                        {
                            padding:10px 20px;
                            svg
                            {
                                height:auto;
                                width:40px;
                            }
                        }
                    }
                }
            }
            .slide
            {
                //background-size: contain;
                //background-position: center center;
                //min-height: 200px;
                width:100%;
                //border:1px solid red;
                display:flex !important; //altrimenti slick, as usual, la sovrascrive con inline-block
                justify-content: flex-end;
            }
            .image
            {
                width:55%;
                position:relative;
                margin:30px 0;
                transform:translateX((5%))
            }
            .thumb
            {
                height: auto;
                width:100%;
            }
            .caption
            {
                position:absolute;
                top:50%;
                left:0;
                width:45%;
                //transform:translateY(-50%);
                padding:$grid-gutter-width/6;
                //border:1px solid green;
            }
            .small
            {
                color:$dark-blue;
                display:none;
                //font-weight: 400;
            }
            .text
            {
                //margin:0.25rem 0;
                color:$tertiary;
            }

            @include media-breakpoint-up(sm)
            {
                margin-bottom:80px;
                .drop-gray-1
                {
                    width:65px;
                    left:18.5%;
                    top:26.5%;
                }
                .drop-gray-2
                {
                    top: 82%;
                    left: 40%;
                    width: 60px;
                }
                .slider
                {

                }
                .slide
                {
                }
                .image
                {
                    width:60%;
                    margin:0;
                    transform:translateX(5%) translateY(-3.5%);
                }
                .thumb
                {
                }
                .caption
                {
                    padding: 0;
                    padding-left:$grid-gutter-width/2;
                    font-size:16px;
                    top:auto;
                    bottom:0;
                    width:30%;
                }
                .small
                {
                    display:block;
                    max-width:220px;
                }
                .text
                {
                    margin:0.5rem 0;
                }
            }

            @include media-breakpoint-up(lg)
            {
                .drop-gray-1
                {
                    width: 160px;
                    left: 5.5%;
                    top: 0;
                }
                .drop-gray-2
                {
                    top: 80%;
                    left: 30%;
                    width: 80px;
                }
                .caption
                {
                    bottom:auto;
                    top:50%;
                    transform: translateY(-30%);
                    width:50%;
                }
                .small
                {
                    max-width:400px;
                    &:first-child
                    {
                        bottom:100%;
                    }
                    &:last-child
                    {
                        top:100%;
                    }
                }
                .text
                {
                    //line-height:120%;
                    margin:1rem 0;
                    //font-size:36px;
                    max-width:680px;
                }                    
            }

            @include media-breakpoint-up(xxl)
            {

                .slider
                {

                }
                .slide
                {
                }
                .image
                {
                    //width:60vw;
                    //transform:none;
                    max-width:1200px;
                    top:0px;
                }
                .thumb
                {
                    top:4px;
                }
                .caption
                {
                    padding:0;
                    margin:0 $grid-gutter-width*2;
                    //font-size:16px;
                    transform:translateY(-50%);
                }
                .small
                {
                    max-width:560px;
                    &:first-child
                    {
                        bottom:100%;
                    }
                    &:last-child
                    {
                        top:100%;
                    }
                }
                .text
                {
                    //line-height:120%;
                    margin:1rem 0;
                    //font-size:36px;
                    max-width:600px;
                }                    
            }            
        }

        .boxed-text
        {
            margin-top:0;
            margin-bottom:0;
            padding-top:0;
            padding-bottom:0;
        }

        .extraQuote
        {
            margin-top:0;
            padding-top:0;
            .text
            {
                font-size: 9px;
                line-height: 1;
                top:38%;
                left:37.5%;
                transform:translateY(-50%);
                width:50%;
                @include media-breakpoint-up(sm)
                {
                    top:42%;
                    font-size: 14px;
                    line-height: 1.4;
                }
                @include media-breakpoint-up(lg)
                {
                    top:40%;
                    font-size: 18px;
                    line-height: 1.4;
                }
                @include media-breakpoint-up(xl)
                {
                    
                    left:42%;
                    width:30.5%;
                    line-height: 1.6;
                    font-size: 20px;
                }
            }
        }   
        
        .credito-travel
        {
            padding-top:0 !important;
            margin-bottom:0 !important;
            .title
            {
                color:$dark-blue;
                text-align: center;
                position:absolute;
                top:30%;
                padding:0 4%;
                font-weight: bold;
            }

            .drop
            {
                margin-top:-40px;
            }

            @include media-breakpoint-up(md)
            {
                .title
                {
                    width:100%;
                }
            }
            @include media-breakpoint-up(xl)
            {
                .title
                {
                    width:100%;
                }
                .drop
                {
                    max-width: 480px;
                    bottom:80px;
                }
            }
        }

        .section--card-with-background
        {
            @include media-breakpoint-up(sm)
            {
                .card
                {
                    width:calc(50% - #{$grid-gutter-width});
                }

                .card:nth-child(3)
                {

                }

                .card:nth-child(2),
                .card:nth-child(4)
                {
                    transform:translateY(15%);
                }
            }
            @include media-breakpoint-up(lg)
            {
                padding-top:280px;
            }
        }

        .section--prefooter
        {
            .image
            {
                background-position: center center;
            }
        }
    }
</style>